module.exports = __webpack_public_path__ + "static/img/sad200-teach.1b5bf6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/support/sad200-teach.png
// module id = aRbz
// module chunks = 0